<template>
  <div class="main">
    <!-- 搜索及筛选 -->
    <div class="whiteBg main-top">
      <el-row>
        <el-col :span="5">
          <div class="box box-align-center mt-input">
            <div class="mti-txt">用户名：</div>
            <el-input v-model="artName" style="width: 200px;" placeholder="请输入用户名" clearable></el-input>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="box box-align-center mt-input">
            <div class="mti-txt">手机号：</div>
            <el-input v-model="cellphoneNumber" style="width: 200px;" placeholder="请输入手机号" clearable></el-input>
          </div>
        </el-col>
        <el-col :span="3">
          <div class="box box-align-center mt-input">
            <div class="mti-txt">注册时间：</div>
            <div class="block">
                <el-date-picker
              v-model="calendarStartTime"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
                </el-date-picker>
            </div>
          </div>
        </el-col>

        <el-col :span="1" :offset="9">
          <div class="box box-align-center box-pack-end mt-btns">
            <el-button type="primary" icon="el-icon-search" @click="getList()">搜索</el-button>
            <el-button plain icon="el-icon-refresh" @click="resetList">重置</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 新增文章按钮 -->
    <div class="whiteBg main-middle">
      <!-- <div class="box box-align-center mt-btns">
        <el-button type="primary" plain icon="el-icon-plus" @click="buildNewTopic">新增</el-button>
      </div> -->
      <dy-table :columns="columns" style="margin-top: 12px" :table-data="tableData" ref="fbTable"
        v-loading="tableLoading" :total="total" :page-num="currentPage" :page-size="pageSize"
        @current-change="onCurrentChange" element-loading-text="加载中"></dy-table>
    </div>

    <el-dialog :title="dialogTitle" :visible.sync="addVisible" width="60%" destroy-on-close
      :close-on-click-modal="false">
      <el-form :model="ruleForm" :rules="rules" label-width="110px" label-position="right" ref="ruleForm">
        <!-- <el-row> -->
        <!-- <el-col :span="10"> -->
          <el-form-item style="font-weight: 600;">
            用户信息
          </el-form-item>
          <el-row>
            <el-col :span="7">
              <el-form-item label="用户名：" prop="bannerName">
                <el-input v-model="ruleForm.username" placeholder="请输入用户名"></el-input>
              </el-form-item>
            </el-col >
            <el-col :span="7">
              <el-form-item label="手机号：" prop="cellphoneNumber">
                <el-input v-model="ruleForm.cellphoneNumber" placeholder="请输入手机号"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        <el-form-item>
            <el-row style="margin-left: 40px; width: 300px; ">
              <el-col  class="textCol" style="background-color: #f6f6ff;" :span="10">
                <el-row>收听时长</el-row>
                <el-row>
                  <div  style="font-weight: 600; font-size: 20px; display: inline-block;">{{totalTime}}</div>
                  <!-- <div v-if="addBanner" style="font-weight: 600; font-size: 20px; display: inline-block;">--</div> -->
                  分钟
                </el-row>
              </el-col>
              <el-col  class="textCol" style="background-color: #fef7f5;" :span="10">
                <el-row>累计打卡</el-row>
                <el-row>
                  <div  style="font-weight: 600; font-size: 20px; display: inline-block;">{{sign}}</div>
                  <!-- <div v-if="addBanner" style="font-weight: 600; font-size: 20px; display: inline-block;">--</div> -->
                  天
                </el-row>
              </el-col>
            </el-row>
        </el-form-item>
        <el-form-item style="font-weight: 600;">
          Ta的睡眠记录
        </el-form-item>
        <dy-table :columns="recordcolumnsNull" style="padding:0 25px 25px 25px" :table-data="sleeptableData" ref="fbTable"
        v-loading="tableLoading" :total="total1" :page-num="currentPage1" :page-size="pageSize1"
        @current-change="onCurrentChangeList" element-loading-text="加载中"></dy-table>

        <div class="box box-align-center box-pack-end mt-btns" style="margin-top: 12px; margin-right: 30px">
          <el-button type="primary" plain @click="submitForm('ruleForm')">保存</el-button>
          <el-button type="danger" plain @click="() => (addVisible = false)">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog title="重置密码" :visible.sync="reset" width="40%" :close-on-click-modal="false">
        <el-form :model="passwordList" :rules="rules2" label-width="120px" label-position="right" ref="passwordList">
          <el-form-item label="密保问题：" >
                <el-input v-model="secretQuestion" disabled></el-input>
            </el-form-item>
            <el-form-item label="密保答案：">
                <el-input v-model="secretAnswer" disabled></el-input>
            </el-form-item>
            <el-form-item label="新密码：" prop="password">
                <el-input v-model="passwordList.password" placeholder="请输入密码"></el-input>
            </el-form-item>

            <div class="box box-align-center box-pack-end mt-btns" style="margin-top: 12px;margin-right: 30px;">
                <el-button type="primary" plain @click="submitPassword('passwordList')">保存</el-button>
                <el-button type="danger" plain @click="() => reset = false">取消</el-button>
            </div>
        </el-form>
    </el-dialog>
    <!-- <el-dialog title="推广位配置" :visible.sync="addChapterVisible" width="60%" :close-on-click-modal="false"
      destroy-on-close>
      <el-button type="primary" icon="el-icon-plus" @click="() => (showAddArticleVisible = true)">添加推广位</el-button>
      <dy-table :columns="chapterColumns" rowKeyName="unionId" style="margin-top: 12px" :isShowPager="false"
        :table-data="chapterTableData" @onDragEnd="(arr) => { bfChapterTableData = arr }" ref="fbTable"
        v-loading="chapterTableLoading" element-loading-text="加载中"></dy-table>
      <div class="box box-align-center box-pack-end mt-btns" style="margin-top: 12px; margin-right: 30px">
        <el-button type="primary" plain @click="submitFormChapter()">保存</el-button>
        <el-button type="danger" plain @click="() => (addChapterVisible = false)">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="添加推广位" append-to-body width="70%" :visible.sync="showAddArticleVisible" destroy-on-close
      :close-on-click-modal="false">
      <channel-common @close-dialog="() => (showAddArticleVisible = false)" @save-data="getSelection"
        :list="chapterTableData"></channel-common>
    </el-dialog> -->
  </div>
</template>
<script>
import DyTable from '@/components/common/dytable';
import channelCommon from '@/components/common/channelCommon/index';
import host from '@/api/index';
import { getChannelList, editChannel, ChannelListupdate,releaseChannel, deleteChannel, saveChooseSpreadSpace, getChannelContent,getAddBanner,subBanner } from '@/api/index';
import { userList, userOpenClose,userListen , userSleepRecord,userSubmit,passwordSubmit,passwordReturn,userDelete } from '@/api/index';

import { encrypt, decrypt } from '@/api/common_encrypt';
import { formatDate, uniqueBy, arrToStr, strToArr } from '@/utils/utils';
import { pushUserType, operatingSystemPhone, statusList, channelType, spreadSpaceType } from '@/utils/commonData';
var that = null;
export default {
  components: {
    DyTable,
    channelCommon,
  },
  data() {
    const { addChannel } = this;
    const { delArticle } = this;
    const { offlineTopic } = this;
    const { onLineTopic } = this;
    const { editArticle } = this;
    const { resetPassword } = this;
    const { deleteUser } = this;
    const { delDialogArticle } = this;
    return {
      url1 :'',
      addBanner:'',
      jumpData:'',
      canzuoPerson: localStorage.getItem('userId'),
      showAddArticleVisible: false,
      artName: null,
      cellphoneNumber:null,
      pushUserType,
      operatingSystemPhone,
      channelType,
      statusList,
      activeName: 'first',
      tableLoading: true,
      topicId: '',
      dialogTitle: '',
      calendarStartTime:{startTime:'',endTime:''},
      columns: [
        {
          type: 'index',
          title: '序号',
        },
        {
          key: 'username',
          title: '用户名',
        },
        {
          key: 'cellphoneNumberStarts',
          title: '手机号',
        },
        {
          // key: 'startTime' + 'startTime',
          key: 'createTime',
          title: '注册时间',
        },
        {
          key: 'status',
          title: '状态',
          render: ({ row }) => {
            if (row.status == 0) {
              return (
                <div>
                  <el-tag type='success' plain  round size='medium '>
                    已启用
                  </el-tag>
                </div>
              );
            } else  {
              return (
                <div>
                  <el-tag type='info' plain round size='medium  '>
                    已禁用
                  </el-tag>
                </div>
              );
            } 
          },
        },
        {
          key: '',
          title: '操作',
          width: '545',
          render: ({ row }) => {
            if (row.status == '1') {
              return (
                <div>
                  <el-link type='primary' style='margin-left:12px' onClick={() => editArticle(row)}>
                    编辑
                  </el-link>
                  <el-link type='success' class="ml12" onClick={() => onLineTopic(row.id)}>
                    启用
                  </el-link>
                  <el-link type='warning' class="ml12"  onClick={() => resetPassword(row.id)}>
                    重置密码
                  </el-link>
                  <el-link type='danger' class="ml12"  onClick={() => deleteUser(row.id)}>
                    删除
                  </el-link>
                </div>
              );
            } else {
              return (
                <div>
                  <el-link type='primary' style='margin-left:12px' onClick={() => editArticle(row)}>
                    编辑
                  </el-link>
                  <el-link type='danger' class="ml12"  onClick={() => offlineTopic(row.id)}>
                    禁用
                  </el-link>
                  <el-link type='warning' class="ml12"  onClick={() => resetPassword(row.id)}>
                    重置密码
                  </el-link>
                  <el-link type='danger' class="ml12"  onClick={() => deleteUser(row.id)}>
                    删除
                  </el-link>
                  
                </div>
              );
            }
          },
        },
      ],
      recordcolumnsNull:[
        {
          type: 'index',
          title: '序号',
        },
        {
          key: 'dateStr',
          title: '时间',
        },
        {
          key: 'timeStr',
          title: '起始时间',
        },
        {
          key: 'audioName',
          title: '音乐',
        },
        {
          key: 'duration',
          title: '时长',
        },

      ],
     
      tableData: [],
      sleeptableData: [],
      total: 0,
      total1:0,
      currentPage: 1,
      pageSize: 10,
      currentPage1: 1,
      pageSize1: 10,
      ruleForm: {
        //新建频道
        username:'',
        cellphoneNumber:'',
        cellphoneNumberStarts:'',
      
      },
      passwordList:{
        password:'',
      },
      passWordId:'',
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        cellphoneNumber: [{ required: true, message: '请输入手机号', trigger: 'blur' }],

      },
      rules2: {
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],

      },
      chapterTableLoading: true,
      chapterColumns: [
        {
          type: "drag",
          render: () => {
            return (
              <i class="el-icon-rank drag-class"></i>
            );
          }
        },
        {
          key: 'spreadSpaceTypeTxt',
          title: '推广位类型',
        },
        {
          key: 'name',
          title: '推广位内容名称',
        },
        {
          key: 'remark',
          title: '备注',
        },
        {
          key: 'status',
          title: '推广位状态',
          render: ({ row }) => {
            if (row.status == 0) {
              return (
                <div>
                  <el-button type='success' round size='mini'>
                    待发布
                  </el-button>
                </div>
              );
            } else if (row.status == 1) {
              return (
                <div>
                  <el-button type='primary' round size='mini'>
                    已发布
                  </el-button>
                </div>
              );
            } else {
              return (
                <div>
                  <el-button type='warning' round size='mini'>
                    已下线
                  </el-button>
                </div>
              );
            }
          },
        },
        {
          key: '',
          title: '操作',
          render: ({ row, index }) => {
            return (
              <div>
                <el-link type='danger' onClick={() => delDialogArticle(row)}>
                  删除
                </el-link>
              </div>
            );
          },
        },
      ],
      chapterTableData: [],
      bfChapterTableData: [], //删除后备份，保存使用
      addVisible: false,
      reset:false,
      addChapterVisible: false,
      value: '',
      status: null,
      currentAdd: null, //当前编辑的推广位
      currentTgwId: '', //设置推广位 ID
      totalTime:'',
      sign:'',
      listobj:'',

      secretQuestion:'',
      secretAnswer:'',
    };
  },
  mounted() {
    that = this;
    that.getList();
  },
  computed: {
    uploadImg() {
      return host.uploadImgUrl;
    },
    headers() {
      return {
        'bg-token': localStorage.getItem('token'), // 直接从本地获取token就行
      };
    },
  },
  methods: {
    //上传图片
    handlePosterPreview(file) {
            console.log(file);
            this.ruleForm.cover = file.data.name;
            this.url1 =  process.env.VUE_APP_API_URL_UPLOAD
            // console.log("1111",process)
            console.log(this.url1 + '/upload/' + file.data.name)
            this.ruleForm.bannerUrl  = this.url1 + '/upload/' + file.data.name
            this.$nextTick(() => {
              this.$forceUpdate()
            })
        },
    changeDateTime() {
      console.log('changeDateTime', that.ruleForm.endTime)
    },
    //保存选择后的数据
    getSelection(arr) {
      console.log('getSelection----', arr)
      let data = arr.map((item, index) => {
        return {
          id: item.id,
          name: item.name,
          remark: item.remark,
          status: item.status,
          spreadSpaceType: item.spreadSpaceType,
          spreadSpaceTypeTxt: item.spreadSpaceTypeTxt,
          isDelete: false,
          unionId: item.unionId
        };
      });
      // let currentArr = JSON.parse(JSON.stringify(that.chapterTableData.concat(data)));
      // that.chapterTableData = uniqueBy(currentArr, 'id');
      that.chapterTableData = data;
      console.log('保存', that.chapterTableData);
      that.bfChapterTableData = JSON.parse(JSON.stringify(that.chapterTableData));
    },
    //新建频道
    buildNewTopic() {
      that.dialogTitle = '新建/修改';
      that.addBanner  = true
      that.ruleForm= {
        bannerName: '',
        bannerUrl: '',
        jumpAudioId: '',
        sort: '',
        calendarStartTime:{startTime:'',endTime:''},
        // startTime: '',
        // endTime: '',
        userId: '',
      };
      console.log(that.ruleForm)
      that.addVisible = true;
    },
    //重置列表
    resetList() {
      that.currentPage = 1;
      that.artName = null;
      that.cellphoneNumber = null;
      that.status = null;
      that.calendarStartTime = '',

      that.getList();
    },
    //编辑频道
    editArticle(obj) {
      console.log(obj, '编辑');
      // that.ruleForm = obj;
      // that.ruleForm.platform = that.ruleForm.platform.length > 0 ? strToArr(that.ruleForm.platform) : '';
      // that.ruleForm.userType = that.ruleForm.userType.length > 0 ? strToArr(that.ruleForm.userType) : '';
      that.addVisible = true;
      that.addBanner = false;
      that.listobj = obj;
      that.getupdateToBanner(obj)
      that.getuseListen(obj)
      that.ruleForm.username = obj.username
      that.ruleForm.cellphoneNumber = obj.cellphoneNumber
    },
    //重置密码
    resetPassword(id) {
      //console.log(id, '重置密码');
      this.getpasswordQuestion(id)
      this.reset = true
      this.passwordList.password = ''
      this.passWordId = id
      // this.$refs.passwordList.resetFields(); 
      
      
    },
    // 密保列表
    getpasswordQuestion(id) {
      let info = {
        pageNum: that.currentPage,
        pageSize: that.pageSize,
      };
      var data = info;
      passwordReturn(data).then((res) => {
        if (res.result == 1) {

          // var ress = JSON.parse(decrypt(res.data));
          var ress = res.data;
          // console.log('密保列表', ress);

          for(let i = 0 ;i <ress.list.length ;i++){
            if(id == ress.list[i].id){
              that.secretQuestion = ress.list[i].secretQuestion
              that.secretAnswer = ress.list[i].secretAnswer
            }
          }
          // console.log(that.secretAnswer)
          // console.log(that.secretQuestion)
          

        } else {
          that.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
      });
    },
    

    //删除弹窗里文章
    delDialogArticle(obj) {
      console.log(obj);
      let index = that.chapterTableData.findIndex((item) => item.id == obj.id);
      that.chapterTableData.splice(index, 1);
      that.bfChapterTableData = JSON.parse(JSON.stringify(that.chapterTableData));
    },
    //删除用户
    deleteUser(id) {
      that
        .$confirm('确认要删除用户吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          let info = {
            userId: id.toString(),
            // userId: localStorage.getItem('userId'),
          };
          console.log(info);
          // var data = info;
          var data = info;
          userDelete(data).then((res) => {
            this.$message({
              showClose: true,
              message: '操作成功',
              type: 'success',
            });
            that.getList();
          });
        });
    },
    
    // 下线频道
    offlineTopic(id) {
      that
        .$confirm('确认要禁用吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          let info = {
            userId: id.toString(),
            // userId: localStorage.getItem('userId'),
            status: 1,
          };
          console.log(info);
          // var data = info;
          var data = info;
          userOpenClose(data).then((res) => {
            this.$message({
              showClose: true,
              message: '操作成功',
              type: 'success',
            });
            that.getList();
          });
        });
    },
    // 上线频道
    onLineTopic(id) {
      that
        .$confirm('确认要启用吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          let info = {
            userId: id.toString(),
            status: 0,
            // userId: localStorage.getItem('userId'),
          };
          debugger;
          console.log(info);
          var data = info;
          userOpenClose(data).then((res) => {
            this.$message({
              showClose: true,
              message: '操作成功',
              type: 'success',
            });
            that.getList();
          });
        });
    },
  

    //编辑
    editChannel() {
      var info = that.ruleForm;
      info.platform = that.ruleForm.platform ? arrToStr(that.ruleForm.platform) : '';
      info.userType = that.ruleForm.userType ? arrToStr(that.ruleForm.userType) : '';
      console.log(info, '我是表单');
      var data = info;
      editChannel(data).then((res) => {
        if (res.result == 1) {
          console.log(res);
          this.addVisible = false;
          that.currentPage = 1;
          that.getList();
          this.$message({
            showClose: true,
            message: '保存成功',
            type: 'success',
          });
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
      });
    },
    //提交修改密码
    submitPassword(passwordList){
      that.$refs[passwordList].validate((valid) => {
        if (valid) {
            var info = {
              password : that.passwordList.password,
              userId:that.passWordId
            };
          console.log(info);
          var data = info;
          console.log("密码")
          passwordSubmit(data).then((res) => {
          if (res.result == 1) {
            this.reset = false
            that.getList();
          } else {
              that.$message({
                  showClose: true,
                  message: res.msg,
                  type: 'error'
              });
          }
          });
          
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 提交表单
    submitForm(formName) {
      that.$refs[formName].validate((valid) => {
        if (valid) {
            var info = {
                // userId: localStorage.getItem('userId'),
                username : that.ruleForm.username,
                cellphoneNumber:that.ruleForm.cellphoneNumber,
                userId:that.listobj.id
            };
          console.log(info);
          var data = info;
          console.log("修改")
          userSubmit(data).then((res) => {
          if (res.result == 1) {
            that.getList();
              that.dialogTableAdd = false;
              that.addVisible = false
          } else {
              that.$message({
                  showClose: true,
                  message: res.msg,
                  type: 'error'
              });
          }
          });
          
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
      //转换为时间戳
      TimeStamp(date){
        console.log("data",date)
        let timestampInMilliseconds = date.getTime();
        let timestampInSeconds = Math.floor(timestampInMilliseconds / 1000);
        return timestampInSeconds;
    },
    //将时间戳转换回来
    convertTimestampToDateTimeRange(serverTimestamp) {
        // 将10位时间戳转换为毫秒级时间戳
        let timestampInMilliseconds = serverTimestamp * 1000;
        let Timedate = new Date(timestampInMilliseconds);
        Timedate = new Date(Timedate.getTime()); 
        // console.log("回显时间",Timedate)
        return Timedate
    },

    onCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    onCurrentChangeList(val) {
      this.currentPage1 = val;
      this.getupdateToBanner(this.listobj);
    },


    // 编辑列表数据
    getupdateToBanner(obj) {
      that.tableLoading = true;
      let info = {
        userId:obj.id,
        pageNum: that.currentPage1,
        pageSize: that.pageSize1,
      };
      console.log("111",info);
      var data = info;
      userSleepRecord(data).then((res) => {
        if (res.result == 1) {
  
          // var ress = JSON.parse(decrypt(res.data));
          var ress = res.data;
          console.log('睡眠列表', ress);
          that.sleeptableData = ress.list
          that.total1 = ress.total;
          that.currentPage1 = ress.pageNum;

          

          that.tableLoading = false;
          that.chapterTableLoading = false;
        } else {
          that.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
      });
    },
    // 编辑列表数据
    getuseListen(obj) {
      that.tableLoading = true;
      let info = {
        userId:obj.id
      };
      console.log(info);
      var data = info;
      userListen(data).then((res) => {
        if (res.result == 1) {
          // var ress = JSON.parse(decrypt(res.data));
          var ress = res.data;
          console.log('累计', ress);

          that.totalTime = ress.totalTime
          that.sign = ress.sign

          that.tableLoading = false;
          that.chapterTableLoading = false;
        } else {
          that.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
      });
    },
    //转换为时间戳
    TimeStamp(date){
        console.log("data",date)
        let timestampInMilliseconds = date.getTime();
        let timestampInSeconds = Math.floor(timestampInMilliseconds / 1000);
        return timestampInSeconds;
    },
    // 列表数据
    getList() {
      that.tableLoading = true;
      if(that.calendarStartTime[0]){
        var info = {
        // status: that.status,
        pageNum: that.currentPage,
        pageSize: that.pageSize,
        username:that.artName,
        cellphoneNumber:that.cellphoneNumber,
        beginTime:formatDate(new Date(that.calendarStartTime[0]), 'yyyy-MM-dd hh:mm:ss'),
        endTime:formatDate(new Date(that.calendarStartTime[1]), 'yyyy-MM-dd hh:mm:ss')

        // channelName: that.artName,
        // needPage: true,
      };
      }else{
        var info = {
        // status: that.status,
        pageNum: that.currentPage,
        pageSize: that.pageSize,
        username:that.artName,
        cellphoneNumber:that.cellphoneNumber,
        // beginTime:that.TimeStamp(that.calendarStartTime[0]),
        // endTime:that.TimeStamp(that.calendarStartTime[1]),

        // channelName: that.artName,
        // needPage: true,
        };
      }
      console.log(info);
      var data = info;
      userList(data).then((res) => {
        if (res.result == 1) {
          // var ress = res.data;
          var ress = res.data;
          console.log('用户列表', ress);
          that.total = ress.total;
          that.currentPage = ress.pageNum;
          that.tableData = ress.list
          // that.tableData = ress.list.map((item) => {
          //   return {
          //     ...item,
          //     timeToget: item.createTime ? formatDate(new Date(item.createTime), 'yyyy-MM-dd hh:mm:ss') : '',
          //   };
          // });
          that.tableLoading = false;
          that.chapterTableLoading = false;
        } else {
          that.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
      });
    },
  },
};

</script>
<style lang="scss" scoped>
/deep/.el-tabs__item {
  min-width: 100px;
  text-align: center;
  padding: 0;
}

/deep/.el-dropdown {
  margin-right: 10px;
}

/deep/.el-form-item__label {
  width: 120px !important;
}

/deep/.el-form-item__content {
  width: 180px !important;
}

/deep/.el-form-item__content {
  margin-left: 0 !important;
}

// /deep/.el-tabs__header {
//     margin: 0;
// }

.main-top {
  padding: 20px 15px;
  // border-bottom: 1px solid rgba(96, 98, 102, 0.2392);

  .mti-txt {
    white-space: nowrap;
  }
}

.main-middle {
  padding: 15px 11px;
}

.common-btns {
  padding: 0 22px 33px;
}
.common-btn {
    width: 76px;
    height: 32px;
    border-radius: 16px !important;
    box-sizing: border-box;
    overflow: hidden;
}
.textCol{
  margin: 5px;
  height: 70px;
  padding-left: 15px;
}
</style>
